<ul class="match-submenu-list">
    @for (item of menuItems; track $index) {
        <li class="match-submenu-list-item" (click)="item.onClick()">
            @if (showItem(item)) {
                <app-svg-icon
                    [icon]="item.icon"
                    class="match-submenu-list-item-icon"
                />
                {{ item.text }}
            }
        </li>
    }
</ul>
